import React from 'react';
import PropTypes from 'prop-types';

import { includesSearchText, formatPrice, isDistributor } from 'helpers/utils';
import {
  HighlightText,
  injectIntl,
  SmartTable,
} from 'components';

const MonthlyInvoicesCardDetails = ({
  formatMessage, info, isFarmer, reportType, searchText, isDistributor,
}) => {
  if (!info) return null;
  const fields = [];

  fields.push({
    className: `highlight company-name ${reportType !== 'monthlyinvoicesales' || isFarmer ? 'wide' : ''} text-wrap`,
    colSpan: 3,
    label: reportType === 'monthlyinvoicesales' ? formatMessage('Customers') : formatMessage('Vendors'),
    name: 'companyName',
    render: row => (
      <HighlightText
        style={{ color: `${(row.index === 0 && isDistributor && reportType !== 'monthlyinvoicesales' && row.companyName === 'Warehouse List') ? '#4694eb' : 'inherit'}` }}
        highlight={searchText}
        text={row.companyName}
      />
    ),
  });

  fields.push({
    label: formatMessage('Orders'),
    name: 'orders',
    render: row => (
      <HighlightText
        style={{ color: `${(row.index === 0 && isDistributor && reportType !== 'monthlyinvoicesales' && row.companyName === 'Warehouse List') ? '#4694eb' : 'inherit'}` }}
        text={row.orders}
      />
    ),
  });
  fields.push({
    label: reportType === 'monthlyinvoicesales' ? formatMessage('Sales') : formatMessage('Purchases'),
    name: 'totalPrice',
    render: row => (
      <HighlightText
        style={{ color: `${(row.index === 0 && isDistributor && reportType !== 'monthlyinvoicesales' && row.companyName === 'Warehouse List') ? '#4694eb' : 'inherit'}` }}
        text={`$${formatPrice(row.totalPrice)}`} />
    ),
  });
  if (reportType === 'monthlyinvoicesales' && !isFarmer) {
    fields.push({
      label: formatMessage('Cost'),
      name: 'totalCost',
      render: row => (
        <HighlightText text={`$${formatPrice(row.totalCost)}`} />
      ),
    });
    fields.push({
      label: formatMessage('Net'),
      name: 'totalNet',
      render: row => (
        <HighlightText text={`$${formatPrice(row.totalNet)}`} />
      ),
    });
  }
  // fields.push({
  //   className: 'bold',
  //   colSpan: 2,
  //   label: formatMessage('Totals'),
  //   name: 'totalPrice',
  //   render: row => (
  //     <HighlightText
  //       highlight={searchText}
  //       text={`$${row.totalPrice}`}
  //     />
  //   ),
  // });

  const filteredData = info.filter(subItem => includesSearchText(
    searchText,
    [
      isFarmer ? subItem.totalCost : subItem.totalPrice,
      subItem.companyName,
    ],
  ));

  return (
    <div className="invoice-detail sales-purchase-history">
      <SmartTable
        data={filteredData}
        fields={fields}
        notMobile
      />
    </div>
  );
};

MonthlyInvoicesCardDetails.propTypes = {
  info: PropTypes.arrayOf(
    PropTypes.shape({
    }),
  ),
  isFarmer: PropTypes.bool.isRequired,
  isDistributor: PropTypes.bool.isRequired,
  reportType: PropTypes.string.isRequired,
  searchText: PropTypes.string,

  formatMessage: PropTypes.func.isRequired,
};

MonthlyInvoicesCardDetails.defaultProps = {
  info: [],
  searchText: '',
};

const wrappedMonthlyInvoicesCardDetails = injectIntl(MonthlyInvoicesCardDetails);
wrappedMonthlyInvoicesCardDetails.displayName = 'MonthlyInvoicesCardDetails';

export default wrappedMonthlyInvoicesCardDetails;
